/**
 * Hero of the Ryerson Gives Back page
 * (`src/pages/why-ryerson/ryerson-commitment/ryerson-gives-back/index.tsx`, its only importer):
 * breadcrumb, title, two paragraphs and, from `lg` up, a heart icon. It renders the Environment,
 * Health & Safety hero layouts from `../../EnvironmentHealthSafety/EnvironmentHealthSafetyHeader/`
 * with the copy in `./RyersonGivesBackHeaderContent.tsx`, so a change to those layouts changes
 * this hero.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import EnvironmentHealthSafetyHeaderMobile from "../../EnvironmentHealthSafety/EnvironmentHealthSafetyHeader/EnvironmentHealthSafetyHeaderMobile";
import EnvironmentHealthSafetyHeaderDesktop from "../../EnvironmentHealthSafety/EnvironmentHealthSafetyHeader/EnvironmentHealthSafetyHeaderDesktop";
import { RyersonGivesBackHeaderContent } from "./RyersonGivesBackHeaderContent";
import { useApplication } from "@ryerson/frontend.application";

/** Renders the hero in the visitor's language, falling back to English. Takes no props. */
const RyersonGivesBackHeader: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	const RGBLangContent =
		RyersonGivesBackHeaderContent[language] || RyersonGivesBackHeaderContent.en;

	return (
		<>
			<Media lessThan="lg">
				<EnvironmentHealthSafetyHeaderMobile {...RGBLangContent} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<EnvironmentHealthSafetyHeaderDesktop {...RGBLangContent} />
			</Media>
		</>
	);
};

export default RyersonGivesBackHeader;
